<template>
  <div class="audit__log">
    <HeaderControlsAuditLog />
    <div class="fixed-top-bar-padding audit-log-wrapper">
      <AuditLogHeader @click="activateTab" :currentTab="currentTab" />
      <div class="container-fluid">
        <div class="deliverable-header">
          <h2>
            <div class="media-call-icon pointer-default">
              <img src="@/csmworkflow/img/audit-log-black.svg"/>
            </div>
            Audit Logs
          </h2>
        </div>
      </div>
      <div class="container-fluid" v-if="auditLogAll">
        <AuditLogBox :auditLogs="auditLogs" />
      </div>
      <div class="container-fluid" v-if="auditLogDeliverablesT">
        <AuditLogBox :auditLogs="auditLogDeliverables" />
      </div>
      <div class="container-fluid" v-if="auditLogProjectsT">
        <AuditLogBox :auditLogs="auditLogProjects" />
      </div>
      <div class="container-fluid" v-if="auditLogTagsT">
        <AuditLogBox :auditLogs="auditLogTags" />
      </div>
      <div class="container-fluid" v-if="auditLogContactsT">
        <AuditLogBox :auditLogs="auditLogContacts" />
      </div>
      <div class="container-fluid" v-if="auditLogCoordinatorsT">
        <AuditLogBox :auditLogs="auditLogCoordinators" />
      </div>
      <div class="container-fluid" v-if="auditLogDepartmentsT">
        <AuditLogBox :auditLogs="auditLogDepartments" />
      </div>
    </div>
  </div>
</template>

<script>
import toast from "../toast";
import HeaderControlsAuditLog from "../components/common/HeaderControlsAuditLog";
import AuditLogHeader from "../components/deliverables/AuditLogHeader";
import AuditLogBox from "../components/deliverables/AuditLogBox";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      comparedJson: {},
      currentTab: 'all',
      auditLogAll: true,
      auditLogDeliverablesT: false,
      auditLogProjectsT: false,
      auditLogTagsT: false,
      auditLogContactsT: false,
      auditLogCoordinatorsT: false,
      auditLogDepartmentsT: false,
    };
  },
  components: {
    HeaderControlsAuditLog,
    AuditLogHeader,
    AuditLogBox
  },
  computed: {
    ...mapGetters([
      "auditLogs", 
      "auditLogTags", 
      "auditLogProjects",
      "auditLogContacts", 
      "auditLogDepartments", 
      "auditLogDeliverables", 
      "auditLogCoordinators", 
    ]),
  },
  methods: {
    activateTab(activeTab) {
      this.auditLogAll = false;
      this.auditLogDeliverablesT = false;
      this.auditLogProjectsT = false;
      this.auditLogTagsT = false;
      this.auditLogContactsT = false;
      this.auditLogCoordinatorsT = false;
      this.auditLogDepartmentsT = false;
      this.currentTab = activeTab;
      switch (activeTab) {
        case "all":
          this.auditLogAll = true;
          break;
        case "deliverables":
          this.auditLogDeliverablesT = true;
          break;
        case "projects":
          this.auditLogProjectsT = true;
          break;
        case "tags":
          this.auditLogTagsT = true;
          break;
        case "contacts":
          this.auditLogContactsT = true;
          break;
        case "coordinators":
          this.auditLogCoordinatorsT = true;
          break;
        case "departments":
          this.auditLogDepartmentsT = true;
          break;
        default:
        // code block
      }
    },
  },
};
</script>

<style>
</style>